import { useTranslation } from 'react-i18next';

export const StatusFilters = [
  { label: 'All', value: 'ALL' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' }
];

export const CardStatusFilters = (t: any) => {
  return [
    { label: t('card-account-management::view-all-cards.text--all'), value: 'all' },
    { label: t('card-account-management::glossary.active'), value: 'active' },
    { label: t('card-account-management::glossary.pending-activation'), value: 'pending-activation' },
    { label: t('card-account-management::glossary.locked'), value: 'locked' },
    { label: t('card-account-management::glossary.suspended'), value: 'suspended' },
    { label: t('card-account-management::glossary.cancelled'), value: 'cancelled' }
  ];
};

export const CardStatusSelectFilters = (t: any) => {
  return [
    { label: t('card-account-management::view-all-cards.text--all'), value: 'ALL' },
    { label: t('card-account-management::glossary.active'), value: 'ACTIVE' },
    { label: t('card-account-management::glossary.pending-activation'), value: 'PENDING_ACTIVATION' },
    { label: t('card-account-management::glossary.locked'), value: 'LOCKED' },
    { label: t('card-account-management::glossary.suspended'), value: 'SUSPENDED' },
    { label: t('card-account-management::glossary.cancelled'), value: 'CANCELLED' }
  ];
};

export const CurrenciesRadios = [
  { label: 'HKD', value: 'HKD' },
  { label: 'USD', value: 'USD' }
];

export const CurrenciesValues = ['HKD', 'USD'];

export const TabKeys = [
  { labelKey: 'card-account-management::account-page.text--account', value: 0 },
  { labelKey: 'card-account-management::account-page.text--card', value: 1 }
];

export const TransactionStatusFilters = (t: any) => {
  return [
    { label: t('card-account-management::card-details.text--pending'), value: 'pending' },
    { label: t('card-account-management::card-details.text--success'), value: 'posted' },
    { label: t('card-account-management::card-details.text--rejected'), value: 'declined' },
    { label: t('card-account-management::card-details.text--void'), value: 'void' }
  ];
};

export const AccountTransactionIntentFilters = (t: any) => {
  return [
    { label: t('card-account-management::glossary.transfer'), value: 'transfer' },
    { label: t('card-account-management::glossary.topup'), value: 'topup' },
    { label: t('card-account-management::glossary.payout'), value: 'payout' }
  ];
};

export const CardNetworkFilters = (t: any) => {
  return [{ label: 'Mastercard', value: 'mastercard' }];
};

export const CreateAccountAssetsFilters = [
  { label: 'HKD', value: 'HKD' },
  { label: 'USD', value: 'USD' },
  { label: 'SGP', value: 'SGP' }
];

export const CardIssueTypeFilters = (t: any) => {
  return [
    { label: t('card-account-management::issue-card.instruction-form.text--card-type-selection-physical'), value: 'physical' },
    { label: t('card-account-management::issue-card.instruction-form.text--card-type-selection-virtual'), value: 'virtual' }
  ];
};

export const CardCancelReasonFilters = (t: any) => {
  return [
    { label: t('credit-card-cancel-card::glossary.lost'), value: 'lost' },
    { label: t('credit-card-cancel-card::glossary.stolen'), value: 'stolen' },
    { label: t('credit-card-cancel-card::glossary.damaged'), value: 'damaged' },
    { label: t('credit-card-cancel-card::glossary.expired'), value: 'expired' },
    { label: t('credit-card-cancel-card::glossary.other'), value: 'other' }
  ];
};

export const CardLimitTitle = (t: any) => {
  return [
    { label: t('card-account-management::set-card-limit.title--daily-purchase-limit'), value: 'PurchaseLimit' },
    { label: t('card-account-management::set-card-limit.title--daily-withdraw-limit'), value: 'ATMWithdrawalLimit' },
    { label: t('card-account-management::set-card-limit.title--daily-limit'), value: 'DailyLimit' },
    { label: t('card-account-management::set-card-limit.title--single-transaction-limit'), value: 'SingleTransactionLimit' }
  ];
};

export const CardLimitSubtitle = (t: any) => {
  return [
    { label: t('card-account-management::set-card-limit.text--set-daily-purchase-limit'), value: 'PurchaseLimit' },
    { label: t('card-account-management::set-card-limit.text--set-atm-withdraw-limit'), value: 'ATMWithdrawalLimit' },
    { label: t('card-account-management::set-card-limit.text--set-daily-limit'), value: 'DailyLimit' },
    { label: t('card-account-management::set-card-limit.text--set-single-transaction-limit'), value: 'SingleTransactionLimit' }
  ];
};

export const CardLimitPlaced = (t: any) => {
  return [
    { label: t('card-account-management::set-card-limit.title--daily-purchase-placed'), value: 'PurchaseLimit' },
    { label: t('card-account-management::set-card-limit.title--daily-atm-placed'), value: 'ATMWithdrawalLimit' },
    { label: t('card-account-management::set-card-limit.title--daily-limit-placed'), value: 'DailyLimit' },
    { label: t('card-account-management::set-card-limit.title--single-transaction-limit-placed'), value: 'SingleTransactionLimit' }
  ];
};
